import styled from "styled-components";
import {Col as AntdCol, Layout, Row} from "antd";
import {Button as StyledButton, Button2} from "../../styles/buttons";
import { Button as AntdButton } from "antd";
import { rgba, darken } from "polished";



export const Container = styled(Layout)`
  padding: 0.5rem 1rem;
  gap: 1rem;
  position: relative;

  @media (min-width: 768px) {
    padding: 1rem 2rem;
  }
`;

export const TableContainer = styled.div`
  @media (max-width: 300px) {
    display: none;
    }

  .ant-pagination-item,
  .ant-pagination-jump-next,
  .ant-pagination-jump-prev {
    display: none;
  }
`;

export const TableContainerAnticipation = styled.div`
  width: 100%;
  overflow-x: auto;

  @media (max-width: 300px) {
    display: none;
  }
  .ant-table th,
  .ant-table td {
    min-width: 150px;
    white-space: nowrap;
  }

`;

export const Button = styled(StyledButton)`
  margin-top: -1px;
  border-radius: 20px;
  width: fit-content;
`

export const Form = styled.form``;

export const Label = styled.label`
  font-size: 18px;
  font-weight: bold;
`;

export const Col = styled(AntdCol)`
  width: 12.4rem;
  margin-bottom: 0.8rem;

  input {
    width: 100%;
    height: 2rem;
    padding: 0 11px                                                                           ;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    background-color: #fff;
    background-image: none;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    transition: all 0.3s;

    &:focus, &:hover {
      border-color: ${(props) => props.theme.colors.cyanDark};
      outline-color: transparent;
    }

    &:focus {
      box-shadow: 0 0 0 2px rgb(22 158 173 / 20%);
    }
  }

  @media (max-width: 768px) {
    min-width: 0em;
  }
`;

export const ResponsiveTable = styled.div`
`;

export const ResponsiveRow = styled.div`
  display: flex;
  margin: 0 12px 12px 0;
  justify-content: space-between;
  padding:5px;

  text-align: center;
  align-items: center;
  align-content: space-between;

  border-radius: 8px;

  @media (min-width: 769px) {
    display: none;
  }
`;

export const ResponsiveColumn = styled.div`
  text-align: center;
  word-wrap: break-word;
  font-size: 12px;

  padding-top: 2px;
  padding-right: 2px;
`;

export const ConfirmationModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 3001;
  width: 300px;
  text-align: center;
`;

export const OverlayStyle = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3000;
`;

export const ModalOverlay = styled.div`
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 999;
  backdrop-filter: blur(1px);
`;

/* Card principal do modal */
export const ModalCard = styled.div`
  position: fixed; z-index: 1000;
  top: 50%; left: 50%; transform: translate(-50%, -50%);
  width: 100%; max-width: 640px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(0,0,0,0.12);
  padding: 20px;

  @media (min-width: 768px) {
    padding: 24px;
  }
`;

/* Cabeçalho */
export const ModalHeader = styled.div`
  margin-bottom: 8px;
`;
export const ModalSub = styled.h3`
  margin: 4px 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
`;

/* Grid dos inputs (igual espírito do FormGrid) */
export const ModalGrid = styled.div`
  display: grid;
  gap: 12px;
  margin-top: 12px;

  grid-template-columns: 1fr; /* mobile */

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(220px, 1fr)); /* tablet */
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, minmax(260px, 1fr)); /* desktop */
  }

  /* herda o estilo do seu InputWrapper (sufixo e prefixo já funcionam) */
  input {
    height: 42px;
    border-radius: 8px;
  }
`;

/* Texto-resumo */
export const Resumo = styled.p`
  margin: 14px 0 0;
  padding: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #111827;
  font-size: 14px;
`;

/* Ações */
export const ModalActions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 16px;
`;

/* Botões alinhados ao seu tema */
export const ConfirmButton = styled(AntdButton).attrs({ type: "primary" })`
  height: 42px;
  border-radius: 10px;
  padding: 0 18px;
  font-weight: 600;
  letter-spacing: 0.02em;
  background-color: ${(p) => p.theme.colors.cyanDark};
  border-color: ${(p) => p.theme.colors.cyanDark};
  color: #fff;
  box-shadow: 0 2px 8px ${(p) => rgba(p.theme.colors.cyanDark, 0.18)};
  &:hover, &:focus {
    background-color: ${(p) => darken(0.08, p.theme.colors.cyanDark)};
    border-color: ${(p) => darken(0.08, p.theme.colors.cyanDark)};
  }
`;

export const GhostButton = styled(AntdButton).attrs({ type: "default" })`
  height: 42px;
  border-radius: 10px;
  padding: 0 18px;
  font-weight: 600;
  letter-spacing: 0.02em;
`;

export const SecondaryButton = styled(Button2)`
  margin-top: -1px;
  border-radius: 20px;
`;


export const TableContainerChargeback = styled.div`
  width: 100%;
  overflow-x: auto;

  /* Se quiser esconder a tabela no mobile — opcional */
  @media (max-width: 768px) {
    display: none;
  }

  /* Impede quebra de linha na tabela inteira */
  .ant-table th,
  .ant-table td {
    white-space: nowrap;
    min-width: 150px; /* ajuste se quiser deixar alguns maiores */
  }
`;

export const BadgeChargeback = styled.span`
  background: #ffc107;
  color: #000;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
`;

export const BadgeDisputa = styled.span`
  background: #ffd6a5;
  color: #000;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
`;

export const BadgeFinalizada = styled.span`
  background: #fbbf24;
  color: #000;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
`;

export const BadgeGanho = styled.span`
  background: #7bcf7a;
  color: #000;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
`;

export const BadgePerdido = styled.span`
  background: #ef4444;
  color: #000;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
`;

export const BtnDetalhes = styled.button`
  padding: 6px 14px;
  border-radius: 8px;
  border: 2px solid #003049;
  background: transparent;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #e6f5ff;
  }
`;

export const ActionRow = styled(Row)`
  margin-top: 8px;
  padding-left: 0.1rem;
  justify-content: flex-start;
`;

export const ActionButton = styled(Button)`
  padding: 0.8rem 3rem;
  font-weight: 600;
  border-radius: 999px;

  display: flex;
  align-items: center;
  justify-content: center;
`;



